import { Component } from 'react';
import sharedStyles from '../single-page.module.scss';
import { FullscreenHost } from '../fullscreen-host.component';
import styles from './convert-pem-to-der.component.module.scss';

interface State {
    pemInput: string;
    derBytes: Uint8Array | null;
    pemLabel: string;
    error: string | null;
}

function pemToDer(pem: string): { bytes: Uint8Array; label: string } {
    const match = pem.match(/-----BEGIN ([^-]+)-----([\s\S]*?)-----END \1-----/);
    if (!match) throw new Error('Could not find a PEM block (looked for -----BEGIN … -----END …-----).');
    const label = match[1];
    const b64 = match[2].replace(/\s+/g, '');
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return { bytes, label };
}

export default class ConvertPemToDerComponent extends Component<{ feature?: string }, State> {
    state: State = {
        pemInput: '',
        derBytes: null,
        pemLabel: '',
        error: null,
    };

    convert = () => {
        try {
            const { bytes, label } = pemToDer(this.state.pemInput);
            this.setState({ derBytes: bytes, pemLabel: label, error: null });
        } catch (e: any) {
            this.setState({ error: e.message || 'Conversion failed', derBytes: null });
        }
    };

    download = () => {
        if (!this.state.derBytes) return;
        const ext = this.state.pemLabel.toLowerCase().includes('key') ? 'der' : 'der';
        const blob = new Blob([new Uint8Array(this.state.derBytes)], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `output.${ext}`;
        a.click();
        URL.revokeObjectURL(url);
    };

    render() {
        const { pemInput, derBytes, pemLabel, error } = this.state;
        return (
            <FullscreenHost>
            <div className="row">
                <div className="col-12 col-md-6">
                    <label className={sharedStyles.label}>
                        PEM input
                        <textarea className={`${sharedStyles.textarea} ${styles.mono}`} rows={14} value={pemInput}
                            spellCheck={false}
                            placeholder={'-----BEGIN CERTIFICATE-----\n…paste PEM block here…\n-----END CERTIFICATE-----'}
                            onChange={e => this.setState({ pemInput: e.target.value, derBytes: null, error: null })} />
                    </label>
                    <button className={sharedStyles.buttonPrimary} onClick={this.convert}>Convert to DER</button>
                    {error && <p className={styles.error} role="alert">{error}</p>}
                </div>
                <div className="col-12 col-md-6">
                    <label className={sharedStyles.label}>DER output</label>
                    {derBytes ? (
                        <div className={styles.result}>
                            <div className={styles.kv}><span>Label</span><code>{pemLabel}</code></div>
                            <div className={styles.kv}><span>Size</span><code>{derBytes.length} bytes</code></div>
                            <div className={styles.preview}>
                                {Array.from(derBytes.slice(0, 64)).map(b => b.toString(16).padStart(2, '0')).join(' ')}
                                {derBytes.length > 64 && '…'}
                            </div>
                            <button className={sharedStyles.buttonPrimary} onClick={this.download}>Download .der file</button>
                        </div>
                    ) : (
                        <div className={styles.placeholder}>Click "Convert to DER" after pasting a PEM block.</div>
                    )}
                </div>
            </div>

            </FullscreenHost>
        );
    }
}
